import { PeopleCountryDto } from "../people-country.dto";
import { PeopleEmployeeDto } from "./people-employee.dto";

export class PeopleEmployeeVisaDto {
    id?: number;
    employeeId?: number;
    countryId?: number;
    visaType?: string;
    visaStartDate?: Date;
    visaEndDate?: Date;
    gnibCard?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employee?: PeopleEmployeeDto;
    country?: PeopleCountryDto;
}